import { useEffect } from 'react';
import { adsConfig } from '@/config/ads';

/**
 * Loads a Google-certified CMP script when configured.
 * Enable adsConfig.cmp after creating Privacy & messaging / Funding Choices in AdSense.
 */
export function CmpBootstrap() {
  useEffect(() => {
    if (!adsConfig.cmp.enabled || !adsConfig.cmp.fundingChoicesScriptUrl) return;
    const existing = document.querySelector(
      'script[data-boozeratio-cmp="funding-choices"]',
    );
    if (existing) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = adsConfig.cmp.fundingChoicesScriptUrl;
    script.dataset.boozeratioCmp = 'funding-choices';
    document.head.appendChild(script);
  }, []);

  return null;
}
